import DialogComp from 'components/Dialog';
import OrganizationForm from 'components/Forms/Organization';
import { Button } from 'components/ui/button';
import { ArrowRight, PlusIcon } from 'lucide-react';
import { EditingContext } from '../../containers/EditingContext';
import React, { useContext } from 'react';
import { Input } from 'components/ui/input';
import { Link } from 'react-router';
import Loading from 'components/Loading';
import { v4 as uuidv4 } from 'uuid';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'components/ui/tabs';
import GlobalView from '../GlobalView';

const MainArea = () => {
  const [filterString, setFilterString] = React.useState<string>('');

  const { data, loading, selectOrg, postOrganizationData } = useContext(EditingContext);

  const orgs = Object.keys(data).map(org => ({ id: data[org].orgId, displayName: data[org].displayName }));

  const filteredOrgs = orgs.filter(org => {
    if (!filterString) return true;
    return org.displayName.toLowerCase().includes(filterString) || org.id.toLowerCase().includes(filterString);
  });

  const [newOrgData, setnewOrgData] = React.useState<Partial<IOrganizationFormData>>({});

  return (
    <Tabs defaultValue="orgs">
      <TabsList className="mb-5">
        <TabsTrigger value="orgs">Organization view</TabsTrigger>
        <TabsTrigger value="global">Global settings</TabsTrigger>
      </TabsList>
      <TabsContent value="orgs">
        <div className="w-full flex">
          <DialogComp
            openButton={
              <Button variant="outline">
                <PlusIcon strokeWidth={3} />
                <div>New organization</div>
              </Button>
            }
            title="New organization"
            content={
              <OrganizationForm
                data={newOrgData}
                onChangeData={(field, value) => setnewOrgData({ ...newOrgData, [field]: value })}
              />
            }
            cancel={{ callback: () => setnewOrgData({}) }}
            accept={{
              callback: () => {
                const orgId = newOrgData.orgId || uuidv4();
                postOrganizationData(orgId, newOrgData as IOrganizationFormData)?.then(res => {
                  if (res) setnewOrgData({});
                });
              },
              disabled: !newOrgData.displayName || !newOrgData.orgGroup || !newOrgData.platforms,
            }}
          />
        </div>
        <div className="my-7">
          {/* <Label htmlFor="userFilter">Search</Label> */}
          <Input
            type="text"
            id="userFilter"
            className="w-100"
            value={filterString}
            onChange={e => setFilterString(e.target.value)}
            placeholder="Search"
          />
        </div>
        <div>
          {loading && (
            <div className="w-full my-13 flex justify-center">
              <Loading />
            </div>
          )}
          {!loading &&
            filteredOrgs.map(org => (
              <div key={org.id} className="my-7">
                <Link to={'organization/' + org.id} onClick={() => selectOrg(org.id)}>
                  <div className="w-full border-2 py-5 px-5 rounded-md flex bg-background">
                    <div className="flex-1">
                      <h3>
                        {org.displayName} / {org.id}
                      </h3>
                    </div>
                    <div>
                      <ArrowRight />
                    </div>
                  </div>
                </Link>
              </div>
            ))}
        </div>
      </TabsContent>
      <TabsContent value="global">
        <div>
          <GlobalView />
        </div>
      </TabsContent>
    </Tabs>
  );
};

export default MainArea;
